import type { Photo, PhotoMeta } from '@/types/photo';
import type { PhotoMetaWire, PhotoWire } from '../schemas/photo';

/**
 * Map the shared photo metadata (width, height, alt_text) to domain format.
 * Absent fields (older API responses) normalize to null.
 */
export function mapPhotoMetaWire(wire: PhotoMetaWire): PhotoMeta {
  return {
    width: wire.width ?? null,
    height: wire.height ?? null,
    altText: wire.alt_text ?? null,
  };
}

/**
 * Convert a check-in photo from wire format to domain format.
 * Maps snake_case to camelCase and the ISO timestamp to Unix milliseconds.
 */
export function mapPhotoWireToDomain(wire: PhotoWire): Photo {
  return {
    id: wire.id,
    checkInId: wire.check_in_id,
    r2Key: wire.r2_key,
    imageUrl: wire.image_url,
    createdAt: new Date(wire.created_at).getTime(),
    position: wire.position ?? null,
    ...mapPhotoMetaWire(wire),
  };
}
